export default "__VITE_ASSET__d30fa300__"